import { Locale } from 'gql/__generated__/graphql'

import authBG from './assets/authBg.svg'
import authLogo from './assets/authLogo.png'
import companyLogo from './assets/companyLogo.svg'
import logoFull from './assets/logo-full_l.svg'
import logoFull_M from './assets/logo-full_m.svg'
import logo from './assets/logo.svg'
import logoText from './assets/logoText.svg'
import './palette.css'

window.PLATFORM = {
  passwordMinLength: 10,
  PlatformName: 'Parta.io',
  announcerDefaultLink: 'https://parta.io/blog/?news_categories=product-release',
  knowledgeBase: 'https://help.parta.io/',
  emailDomain: 'parta.io',
  supportChat: { type: 'hubspot', url: 'https://js-na1.hs-scripts.com/44139228.js' },
  contactSales: { type: 'hubspot', url: 'https://meetings.hubspot.com/a-romanovskiy/demo-parta-io?embed=true' },
  termsOfService:
    'https://terms-service-and-privacy-policy.s3.amazonaws.com/Parta/2024_Parta.io_Terms_of_Service.pdf',
  privacyPolicy:
    'https://terms-service-and-privacy-policy.s3.amazonaws.com/Parta/2024_Parta.io_Privacy_Policy.pdf',
  trialLink: 'https://parta.io/',
  hasLmsIntegration: true,
  allowSignup: true,
  showPpAndTOS: true,
  authBG,
  authLogo,
  companyLogo,
  logo,
  logoFull,
  logoFull_M,
  logoText,
  courseHtmlFooter: '<b>Created in Parta.io.</b> Collaborative eLearning creation platform.',
  fallbackLng: 'en',
  phraseIntegrationGuideLink:
    'https://help.parta.io/course-translation/connect-integration-to-phrase',
  sentryDsn:
    'https://67005f8a3c0f788a6412c4a41357e14e@o4507888706453504.ingest.us.sentry.io/4509326327545856',
  unsupportedLinksHelp:
    'https://help.parta.io/editor/edit-elements/set-media-and-content-elements/embedded-code#supported-links',
  embeddedHelp: {
    html: 'https://help.parta.io/editor/edit-elements/set-media-and-content-elements/embedded-code#html',
    archive:
      'https://help.parta.io/editor/edit-elements/set-media-and-content-elements/embedded-code#archive',
  },
  languages: [{ value: Locale.EN, label: 'English' }],
  slackLink: 'https://parta.io/parta-io-community/',
}
